import assets from "assets";
import Button from "components/widgets/button";
import { CgSpinnerTwo } from "react-icons/cg";
import { AiFillHome } from "react-icons/ai";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="w-full  flex flex-col items-center justify-center " style={{ height: "calc(100vh - 184px)" }}>
      <img src={assets.icon} alt="" className="w-28 object-contain  mb-2" />
      <h1>Awwwww... Don't Cry.</h1>
      <h2 className="mt-2 mb-8 font-light">It's just a 404 Error!</h2>
      <Link to="/">
        <Button label="Go To Home" icon={<AiFillHome />} />
      </Link>
    </div>
  );
}

export function SuspenseScreen() {
  return (
    <div className="w-full flex flex-col items-center justify-center -mt-16" style={{ height: "calc(100vh - 184px)" }}>
      <img src={assets.icon} alt="" className="w-20 object-contain mb-2" />
      <h2>TextHere</h2>
      <CgSpinnerTwo size="32" className="text-primary animate-spin mt-8" />
    </div>
  );
}
export function LoadingScreen() {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center ">
      <img src={assets.icon} alt="" className="w-28 object-contain mb-2" />
      <h1>TextHere</h1>
      <CgSpinnerTwo size="32" className="text-primary animate-spin mt-8" />
    </div>
  );
}

export default NotFound;
